import { render, staticRenderFns } from "./CheckoutCompleted.vue?vue&type=template&id=2913d047&"
import script from "./CheckoutCompleted.vue?vue&type=script&lang=js&"
export * from "./CheckoutCompleted.vue?vue&type=script&lang=js&"
import style0 from "./CheckoutCompleted.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports